__webpack_require__.p = "/wp-content/plugins/prime-extensions/assets/dashboard/";